<template>
  <b-container v-if="market">
    <head-block :title="$t('pages.bookings.market_terms')" />
    <div v-html="market.paymentTerms" />
  </b-container>
</template>

<script>

  import HeadBlock from "@base/components/HeadBlock.vue";
  import {mapState} from "vuex";

  export default {
    name: 'MarketTermsView',
    components: { HeadBlock },

    data () {
      return {
        loading: false,
        loader: null,
      }
    },

    props: {
      isCustomerView: {
        type: Boolean,
        default: false
      },
    },

    computed: {
      ...mapState({
      market () {
        return this.isCustomerView
          ? this.$store.state.userMarket
          : this.$store.state.anonMarket
        }
      }),
    },
  }
</script>

<style>

</style>
